import MyClosetTab from './MyClosetTab';

export default MyClosetTab;
